<template>
  <v-row class="my-2">
      <v-col lg="2" class="d-flex justify-center">
        <v-img :src="event.picId" max-width="100" height="100" class="rounded-circle"></v-img>
      </v-col>
      <v-col lg="10" class="">
        <v-row>
         <h3>{{event.name}}</h3> 
        </v-row>
        <v-row>
          <v-icon color="light-green">mdi-account-multiple</v-icon>
          <p>{{event.participants}} participants</p>
        </v-row>
        <v-row class="">
          <v-icon color="light-green">mdi-calendar-blank-outline</v-icon>
          <p>{{event.time}}</p>
        </v-row>
      </v-col>
      <v-divider></v-divider>
  </v-row>
</template>

<script>
export default {
    name:'JoinedEvent',
    props: ['event']
}
</script>

<style>

</style>